/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import global from './utils/global'
import store from './store'
import api from './http'
import 'font-awesome/css/font-awesome.min.css'
import VueKindEditor from './plugin/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all.js'
import '../static/kindeditor/lang/zh-CN.js'
import VueParticles from 'vue-particles'

Vue.config.productionTip = false
// 注册 vue-kikindeditor plugin
Vue.use(VueKindEditor)
Vue.use(ElementUI)
Vue.use(api)
Vue.use(VueParticles)

Vue.prototype.global = global

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js